import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  /**
   * a title
   */
  title = 'ciao';

  /**
   * url del mio sito
   */
  url = 'fabiobiondi.io';

  /**
   * add operation
   */
  add(a: number, b: number) {
    return a + b;
  }
}
